var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g", [
    _c("defs", [
      _c("path", {
        attrs: {
          id: "zona-3-a",
          d:
            "M19.05,20.375 C18.251,20.375 17.6,19.724 17.6,18.925 C17.6,18.125 18.251,17.475 19.05,17.475 C19.849,17.475 20.5,18.125 20.5,18.925 C20.5,19.724 19.849,20.375 19.05,20.375 M16.508,18.844 L8.083,18.383 C8.016,17.368 7.361,16.518 6.448,16.172 L7.65,10.822 C7.741,10.832 7.831,10.85 7.925,10.85 C9.331,10.85 10.475,9.706 10.475,8.3 C10.475,8.25 10.463,8.203 10.46,8.153 L16.224,6.815 C16.455,7.214 16.787,7.541 17.189,7.767 L15.747,11.27 C15.681,11.265 15.617,11.25 15.55,11.25 C14.144,11.25 13,12.394 13,13.8 C13,15.206 14.144,16.35 15.55,16.35 C15.889,16.35 16.211,16.28 16.508,16.16 L17.37,17.022 C16.86,17.473 16.531,18.117 16.508,18.844 M5.55,20 C4.751,20 4.1,19.349 4.1,18.55 C4.1,17.75 4.751,17.1 5.55,17.1 C6.349,17.1 7,17.75 7,18.55 C7,19.349 6.349,20 5.55,20 M7.925,6.85 C8.724,6.85 9.375,7.5 9.375,8.3 C9.375,9.099 8.724,9.75 7.925,9.75 C7.126,9.75 6.475,9.099 6.475,8.3 C6.475,7.5 7.126,6.85 7.925,6.85 M18.425,4.1 C19.224,4.1 19.875,4.75 19.875,5.55 C19.875,6.349 19.224,7 18.425,7 C17.626,7 16.975,6.349 16.975,5.55 C16.975,4.75 17.626,4.1 18.425,4.1 M15.55,15.25 C14.751,15.25 14.1,14.599 14.1,13.8 C14.1,13 14.751,12.35 15.55,12.35 C16.349,12.35 17,13 17,13.8 C17,14.599 16.349,15.25 15.55,15.25 M19.05,16.375 C18.816,16.375 18.594,16.417 18.379,16.476 L17.421,15.519 C17.839,15.064 18.1,14.464 18.1,13.8 C18.1,12.852 17.573,12.032 16.804,11.593 L18.249,8.082 C18.309,8.086 18.365,8.1 18.425,8.1 C19.831,8.1 20.975,6.956 20.975,5.55 C20.975,4.144 19.831,3 18.425,3 C17.019,3 15.875,4.144 15.875,5.55 C15.875,5.623 15.891,5.691 15.897,5.762 L10.158,7.094 C9.726,6.298 8.893,5.75 7.925,5.75 C6.519,5.75 5.375,6.894 5.375,8.3 C5.375,9.22 5.869,10.02 6.601,10.469 L5.355,16.02 C4.041,16.121 3,17.21 3,18.55 C3,19.956 4.144,21.1 5.55,21.1 C6.629,21.1 7.548,20.424 7.92,19.476 L16.723,19.958 C17.121,20.85 18.012,21.475 19.05,21.475 C20.456,21.475 21.6,20.331 21.6,18.925 C21.6,17.519 20.456,16.375 19.05,16.375"
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "g",
      {
        attrs: {
          fill: "none",
          "fill-rule": "evenodd",
          transform: "translate(-3 -3)"
        }
      },
      [
        _c("mask", { attrs: { id: "zona-3-b", fill: "#fff" } }, [
          _c("use", { attrs: { "xlink:href": "#zona-3-a" } })
        ]),
        _vm._v(" "),
        _c("use", {
          attrs: {
            fill: _vm.currentColor,
            opacity: _vm.opacity,
            "xlink:href": "#zona-3-a"
          }
        }),
        _vm._v(" "),
        _c("rect", {
          staticStyle: { "mix-blend-mode": "color-burn" },
          attrs: {
            width: "24",
            height: "24",
            fill: "#E3E3E3",
            "fill-opacity": ".01",
            mask: "url(#zona-3-b)"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }